<template>
    <div>
        Chatbot credit is almost over. %90 ChatBot credit Used
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatBotCreditLow",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
